import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const AuditLogsPageStyled = styled(Box)(() => ({
  ".content-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    marginTop: "6px",
  },

  ".filters-container": {
    display: "flex",
    alignItems: "flex-end",
    gap: "16px",
  },
}));
